/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    il_opus_reference_id: '',
    il_trade_partner_id_client: '',
    il_team_id: '',
    il_trade_partner_id_forwarder: '',
    mawb: '',
    incoterm: '',
    etd: null,
    eta: null,
    feta: null,
    il_location_id_aol: '',
    il_location_id_aod: '',
    il_location_id_faod: '',
    il_air_import_hbl: [
        {
            id: 1,
            hawb: '',
            il_air_import_hbl_alias: [],
            il_trade_partner_id_shipper: '',
            il_trade_partner_id_consignee: '',
            reference: '',
        },
    ],
    rate_copy: false,
};

const aimShipmentFormSlice = createSlice({
    name: 'aimNewShipmentForm',
    initialState,
    reducers: {
        setFormData: (state, action) => {
            return { ...state, ...action.payload };
        },
        addHAWB: (state, action) => {
            state.il_air_import_hbl = [...state.il_air_import_hbl, action.payload];
        },
        deleteHAWB: (state, action) => {
            const tabId = action.payload;
            return { ...state, il_air_import_hbl: state.il_air_import_hbl.filter((hawb) => hawb.id !== tabId) };
        },
        updateHAWBtitle: (state, action) => {
            const { id, newTitle } = action.payload;
            state.il_air_import_hbl = state.il_air_import_hbl.map((item) =>
                item.id === id ? { ...item, hawb: newTitle } : item
            );
        },
        updateHAWB: (state, action) => {
            const { id, key, value } = action.payload;
            const index = state.il_air_import_hbl.findIndex((hbl) => hbl.id === id);
            if (index !== -1) {
                const hblItem = state.il_air_import_hbl[index];

                if (key in hblItem) {
                    state.il_air_import_hbl[index][key] = value;
                }
            }
        },
        addAlias: (state, action) => {
            const { hawbId, alias } = action.payload;
            state.il_air_import_hbl = state.il_air_import_hbl.map((item) =>
                item.id === hawbId
                    ? { ...item, il_air_import_hbl_alias: [...item.il_air_import_hbl_alias, alias] }
                    : item
            );
        },
        updateAlias: (state, action) => {
            const { hawbId, aliasId, updatedAlias } = action.payload;
            state.il_air_import_hbl = state.il_air_import_hbl.map((item) =>
                item.id === hawbId
                    ? {
                          ...item,
                          il_air_import_hbl_alias: item.il_air_import_hbl_alias.map((aliasItem) =>
                              aliasItem.id === aliasId ? { ...aliasItem, ...updatedAlias } : aliasItem
                          ),
                      }
                    : item
            );
        },
        deleteAlias: (state, action) => {
            const { hawbId, aliasId } = action.payload;
            state.il_air_import_hbl = state.il_air_import_hbl.map((item) =>
                item.id === hawbId
                    ? {
                          ...item,
                          il_air_import_hbl_alias: item.il_air_import_hbl_alias.filter(
                              (aliasItem) => aliasItem.id !== aliasId
                          ),
                      }
                    : item
            );
        },
        resetFormData: (state) => {
            return initialState;
        },
    },
});

export const {
    setFormData,
    resetFormData,
    addHAWB,
    deleteHAWB,
    updateHAWBtitle,
    updateHAWB,
    addAlias,
    updateAlias,
    deleteAlias,
} = aimShipmentFormSlice.actions;
export default aimShipmentFormSlice.reducer;
